import { render, staticRenderFns } from "./QEditPermissions.vue?vue&type=template&id=c3ceb990&"
import script from "./QEditPermissions.vue?vue&type=script&lang=js&"
export * from "./QEditPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports